import {computed} from 'vue';
import type {NuxtError} from '#app';

export const usePageNotFound = (error: NuxtError) => {
    const showStatusCode = computed(() => {
        return error.status !== 404;
    });

    const errorTitle = computed(() => {
        return error.status === 404
            ? 'Страница не найдена'
            : 'Something went wrong';
    });

    const errorDescription = computed(() => {
        return error.status === 404
            ? 'К сожалению, запрашиваемая вами страница была удалена, перемещена или никогда не существовала. Пожалуйста, проверьте правильность ссылки или вернитесь на главную.'
            : 'Please try again later.';
    });

    const handleBackToHomeClick = () => {
        void clearError();
    };

    return {
        showStatusCode,
        errorTitle,
        errorDescription,
        handleBackToHomeClick,
    };
};
